<div
  class="rateing-wrap"
  [class.rateing-wrap--long-scale]="isLongRadioScale"
  [formGroup]="service.formGroup"
>
  <!-- SCALE MODE: Material slider -->
  <ng-container *ngIf="useScale; else nonScale">
    <div
      [formGroup]="service.formGroup"
      [ngClass]="{
        'scale-slider-wrap': true,
        'is-unanswered': !hasValue,
        'has-gradient': useGradient,
        'has-scale':
          !useGradient &&
          service.themeService.getThemeColor(service.themeService.ThemeItemEnum.scaleTrackColour),
        'has-scale-selected':
          !useGradient &&
          service.themeService.getThemeColor(
            service.themeService.ThemeItemEnum.scaleTrackSelectedColour
          )
      }"
      [ngStyle]="{
        '--scale-gradient': useGradient
          ? scaleGradient
          : service.themeService.getThemeColor(service.themeService.ThemeItemEnum.scaleTrackColour),
        '--scale-selected-track-color': service.themeService.getThemeColor(
          service.themeService.ThemeItemEnum.scaleTrackSelectedColour
        )
      }"
    >
      <mat-slider
        class="scale-slider"
        [min]="0"
        [max]="scaleMaxIndex"
        step="1"
        discrete
        showTickMarks
        [displayWith]="displayIndex"
      >
        <input
          matSliderThumb
          [value]="scaleIndex"
          (valueChange)="onScaleIndexChange($event)"
          (dragEnd)="confirmScaleIndex($event.value)"
          (keyup)="confirmScaleFromKeyboard($event)"
        />
      </mat-slider>
      <div class="scale-slider-labels">
        <span
          *ngFor="let range of scaleRanges; let i = index"
          class="scale-slider-label"
          [style.left.%]="indexPosition(i)"
          [matTooltip]="range.description"
        >
          <mat-icon *ngIf="useIcons" [svgIcon]="'rating-' + range.value" class="align-middle" />
          <ng-container *ngIf="!useIcons">{{ range.value }}</ng-container>
        </span>
      </div>
      <div class="scale-segmented-labels">
        <span class="scale-segmented-label scale-segmented-label--start">{{ firstLabel }}</span>
        <span class="scale-segmented-label scale-segmented-label--end">{{ lastLabel }}</span>
      </div>
    </div>
  </ng-container>

  <ng-template #nonScale>
    <div
      class="box"
      *ngFor="let range of question.questionRangeGroup.ranges"
      (click)="selectOption(range.value)"
      [ngStyle]="{ cursor: 'pointer' }"
    >
      <ng-container *ngIf="useIcons">
        <div
          class="highlight"
          [class.active]="control.value === range.value"
          [matTooltip]="range.description"
        >
          <mat-icon [svgIcon]="'rating-' + range.value" class="align-middle" />
        </div>
      </ng-container>
      <ng-container *ngIf="!useIcons">
        <input
          #input
          type="radio"
          [formControlName]="question.getName()"
          [value]="range.value"
          class="align-middle me-1"
          [ngStyle]="{
            'accent-color': service.themeService.getThemeColor(
              service.themeService.ThemeItemEnum.radioButton
            )
          }"
        />
        <span>{{ range.description }} </span>
      </ng-container>
    </div>
  </ng-template>
</div>
